export const HEADER_ACTIVE_ROLES = 'lendi-active-roles';

export enum ACTIVE_ROLES_VALUES {
  BORROWER = 'BORROWER',
  GUARANTOR = 'GUARANTOR',
  APP_READONLY = 'APP_READONLY',
}

export enum ACTION_TYPES {
  UPDATE_ACTIVE_ROLES = 'UPDATE_ACTIVE_ROLES',
  UPDATE_ACTIVE_ROLES_ERROR = 'UPDATE_ACTIVE_ROLES_ERROR',
}
